import { createFileRoute } from "@tanstack/react-router";
import {
  SpringsLandingPage,
  buildSpringsLandingHead,
} from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-seo-northgate");

export const Route = createFileRoute("/colorado-springs-seo-northgate")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
